import { render, staticRenderFns } from "./compensateDetails.vue?vue&type=template&id=76df7208&scoped=true&"
import script from "./compensateDetails.vue?vue&type=script&lang=js&"
export * from "./compensateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df7208",
  null
  
)

export default component.exports